import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function CallToAction() {
  return <section id="contact" className="py-24 md:py-32 relative overflow-hidden" data-id="element-11">
      {/* Soft gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-sage-200/40 via-cream-100 to-lavender-200/40 -z-10" data-id="element-12" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-13">
        <FadeIn data-id="element-14">
          <h2 className="text-4xl md:text-6xl font-serif text-slate-900 leading-tight mb-6" data-id="element-15">
            Ready to Make Your Courses{' '}
            <span className="italic text-sage-800" data-id="element-16">Discoverable?</span>
          </h2>
          <p className="text-xl text-slate-700 mb-10 max-w-2xl mx-auto" data-id="element-17">
            Let's discuss how our academic-grade SEO and content strategies can
            drive sustainable enrollment growth for your platform.
          </p>

          <div className="bg-white/60 backdrop-blur-md p-8 md:p-12 rounded-3xl border border-white shadow-xl shadow-slate-900/5 max-w-2xl mx-auto" data-id="element-18">
            <form className="flex flex-col gap-4" onSubmit={e => e.preventDefault()} data-id="element-19">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-20">
                <input type="text" placeholder="Name" className="w-full px-5 py-4 rounded-xl bg-white border border-cream-200 focus:outline-none focus:ring-2 focus:ring-sage-300 transition-shadow" data-id="element-21" />
                <input type="email" placeholder="Work Email" className="w-full px-5 py-4 rounded-xl bg-white border border-cream-200 focus:outline-none focus:ring-2 focus:ring-sage-300 transition-shadow" data-id="element-22" />
              </div>
              <input type="text" placeholder="Platform URL" className="w-full px-5 py-4 rounded-xl bg-white border border-cream-200 focus:outline-none focus:ring-2 focus:ring-sage-300 transition-shadow" data-id="element-23" />
              <button type="submit" className="group w-full flex items-center justify-center gap-2 px-8 py-4 bg-slate-900 text-white rounded-xl font-medium hover:bg-slate-800 transition-all mt-2" data-id="element-24">
                Schedule a Consultation
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-25" />
              </button>
            </form>
            <p className="text-sm text-slate-500 mt-6" data-id="element-26">
              No commitment required. We'll start with a brief discovery call.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}